import { reactive, ref, computed, watch } from 'vue'
import * as track from './tracking.js'

export const offerIsNull = ref(true)
export const selected = ref(false)
export const price = ref(null)
export const messages = reactive({ info: [], warning: [] })
export const state = reactive({
  modelYear: null,
  horsePower: null,
  make: null,
  modelAndMakeId: null,
  mileage: null,
  warranty: null,
  isEngineTuned: null,
  hasUndergoneRepairs: null,
  firstRegistration: null,
})
const noMessages = computed(
  () => !(messages.info.length || messages.warning.length),
)
export const noOffer = computed(() => noMessages.value && offerIsNull.value)

let tracked = false
watch(noOffer, (hasNoOffer) => {
  if (!hasNoOffer && !tracked) {
    track.view()
    tracked = true
  }
})
